import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationDialog from 'components/ConfirmationDialog';

const PrintCancelDialog = ({
  isOpen,
  closeAction = () => {},
  confirmAction = () => {},
  ...props
}) => {
  return (
    <ConfirmationDialog
      cancel={{
        label: 'Never Mind',
        action: closeAction,
      }}
      confirm={{
        label: 'Proceed',
        action: confirmAction,
      }}
      id={'confirmCancelPrintDialog'}
      isOpen={isOpen}
      labelledById="print-cancel"
      message="All unfinished print jobs will be cancelled."
      title="Are you sure you want to proceed?"
      titleComponent="h5"
      {...props}
    />
  );
};

PrintCancelDialog.propTypes = {
  isOpen: PropTypes.bool,
  closeAction: PropTypes.func,
  confirmAction: PropTypes.func,
};

export default PrintCancelDialog;
